import http from "./http";
import apis from "../config/apis.json";

const api = 
    process.env.REACT_APP_ENVIRON === "development"
    ? apis.dev
    : process.env.REACT_APP_ENVIRON === "production"
    ? apis.prod
    : apis.test;

export async function getUserOrganizations() {
    const response = await http.get(`${api}/organization/`);
    return response;
}

export async function getOrganizationById(organizationId) {
    const response = await http.get(`${api}/organization/${organizationId}`);
    return response;
}

// API Key management functions
export async function generateApiKey(organizationId) {
    const response = await http.post(`${api}/organization/${organizationId}/api-key/generate`);
    return response;
}

export async function getApiKey(organizationId) {
    const response = await http.get(`${api}/organization/${organizationId}/api-key`);
    return response;
}

export async function revokeApiKey(organizationId) {
    const response = await http.delete(`${api}/organization/${organizationId}/api-key`);
    return response;
}

// Member management functions
export async function addMemberToOrganization(organizationId, email, role = 'viewer') {
    const response = await http.post(
        `${api}/organization/${organizationId}/members`,
        { email, role }
    );
    return response;
}

export async function getOrganizationMembers(organizationId) {
    const response = await http.get(`${api}/organization/${organizationId}/members`);
    return response;
}

export async function updateMemberRole(organizationId, memberId, role) {
    const response = await http.put(
        `${api}/organization/${organizationId}/members/${memberId}/role`,
        { role }
    );
    return response;
}

export async function removeMemberFromOrganization(organizationId, memberId) {
    const response = await http.delete(
        `${api}/organization/${organizationId}/members/${memberId}`
    );
    return response;
}

// Create a new organization
export async function createOrganization(organizationData) {
    const response = await http.post(`${api}/organization`, organizationData);
    return response;
}

// Billing management functions
export async function getOrganizationBilling(organizationId) {
    const response = await http.get(`${api}/organization/${organizationId}/billing`);
    return response;
}